import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function PainSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0
    }
  };
  return <section className="py-20 bg-white text-gray-900" data-id="element-156">
      <div className="max-w-2xl mx-auto px-4" data-id="element-157">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="space-y-8" data-id="element-158">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-8" data-id="element-159">
            No siempre hay una crisis visible. <br data-id="element-160" />
            <span className="text-red-700" data-id="element-161">A veces no pasó “nada grave”.</span>
          </h2>

          <p className="text-xl text-gray-700 font-medium" data-id="element-162">Pero igual:</p>

          <ul className="space-y-4 text-lg text-gray-800" data-id="element-163">
            {['te cuesta concentrarte', 'estás más irritable', 'sentís cansancio mental', 'dudás más de vos', 'todo pesa un poco más'].map((item, index) => <motion.li key={index} variants={itemVariants} className="flex items-center gap-3 p-2 border-l-4 border-red-200 bg-red-50/50" data-id="element-164">
                <div className="w-2 h-2 rounded-full bg-red-600 flex-shrink-0" data-id="element-165" />
                <span data-id="element-166">{item}</span>
              </motion.li>)}
          </ul>

          <div className="mt-10" data-id="element-167">
            <p className="text-xl font-bold text-gray-900 mb-4" data-id="element-168">
              Y lo peor es esto:
            </p>

            <motion.div variants={itemVariants} className="bg-amber-100 border-l-4 border-amber-500 p-6 rounded-r-lg shadow-sm relative" data-id="element-169">
              <AlertCircle className="absolute top-4 right-4 text-amber-300 w-8 h-8 opacity-50" data-id="element-170" />
              <p className="text-xl md:text-2xl font-serif italic text-gray-800 leading-relaxed" data-id="element-171">
                “No sé explicar bien qué me pasa… pero sé que no estoy como
                antes.”
              </p>
            </motion.div>
          </div>

          <motion.p variants={itemVariants} className="text-center text-lg font-medium text-gray-600 mt-8" data-id="element-172">
            Si te reconocés ahí, seguí leyendo. 👇
          </motion.p>
        </motion.div>
      </div>
    </section>;
}